module.exports = __WEBPACK_EXTERNAL_MODULE_24__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable","prototype"],"commonjs":"rxjs/operator/filter","commonjs2":"rxjs/operator/filter","amd":"rxjs/operator/filter"}
// module id = 24
// module chunks = 0 1